// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoItem_info___un9q"};